<template>
  <div>
    <v-server-table
      :url="url"
      :columns="columns"
      :options="options"
      :theme="theme"
      ref="table"
      id="dataTable"
    >
      <template slot="id" scope="props">
        <input
          v-model="selectMarkedRows"
          type="checkbox"
          :ref="'check' + props.index"
          @click="
            unmarkAll($event, props.index, 'check' + props.index, props.row)
          "
          class="form-check"
          :value="props.row"
        />
      </template>

      <template slot="afterFilter">
        <tr class="VueTables__no-results">
          <b-button @click="resetFilters">Limpiar filtro</b-button>
        </tr>

        <tr v-if="loading" class="VueTables__no-results">
          <b-spinner
            v-if="loading"
            variant="primary"
            class="ml-2 mt-1"
            small
            label="Small Spinner"
          />
        </tr>

        <tr class="VueTables__no-results">
          <download-excel v-if="url != ''" :headings="headings" :url="url" />
        </tr>
        <tr class="VueTables__no-results">
          <b-button @click="assignArea">Asignar área</b-button>
        </tr>
      </template>

      <div slot="net_kilograms" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.net_kilograms | num_format }}
        </div>
      </div>

      <div class="text-center" slot="actions" slot-scope="props">
        <a
          target="_blank"
          href="#"
          @click.prevent=""
          class="fa fa-lg fa-search text-primary"
        />&nbsp;
      </div>
    </v-server-table>
    <assign-area-modal
      ref="AssignAreaModal"
      :Areas="Areas"
      :markedRows="markedRows"
    ></assign-area-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import DownloadExcel from "./DownloadExcel";
import { bus } from "../main";
import AssignAreaModal from "./stock/AssignAreaModal";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "StockList",
  props: {
    clickeable: {
      type: Boolean,
      default: false
    },
    column_display: {
      type: Object,
      default: {}
    },
    columns: {
      type: Array,
      default: []
    },
    url: {
      type: String,
      default: ""
    },
    filterable: {
      type: Array,
      default: []
    },
    headings: {
      type: Object,
      default: {}
    },
    listColumns: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    ServerTable,
    DownloadExcel,
    AssignAreaModal
  },
  created() {
    bus.$off("refreshStockListProcess");
    bus.$on("refreshStockListProcess", () => {
      this.$refs.table.refresh();
    });
    this.getAreas();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
      this.$emit("on-loading", true);
      this.markedRows = [];
      this.selectMarkedRows = [];
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
      this.$emit("on-loading", false);
      this.markedRows = [];
      this.selectMarkedRows = [];
    });
  },
  data() {
    return {
      title: "Listado de stock",
      loading: false,
      report: "report",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields2: {
        Exportadora: "client_customer_name"
      },
      theme: "bootstrap4",
      template: "default",
      options: {
        rowClassCallback(row) {
          return row.active === true ? "text-info" : "";
        },
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];

          for (let key in results) {
            const item = results[key];
            const returnedTarget = Object.assign(item, { active: false });
            items.push(returnedTarget);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 15,
        perPageValues: [15, 25, 50, 100],
        filterByColumn: true,
        filterable: this.filterable,
        headings: this.headings,
        columnsDisplay: this.column_display,
        listColumns: this.listColumns,
        debounce: 1000,
        columnsDropdown: true,
        columnsClasses: {
          quantity: "text-right",
          net_kilograms: "text-right"
        }
      },
      markedRows: [],
      selectMarkedRows: [],
      Areas: []
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  computed: {
    name() {
      return "Stock " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    }
  },
  methods: {
    assignArea() {
      if (this.markedRows.length < 1) {
        this.$toast.info(
          "Debe seleccionar por lo menos un contenido para poder asignar una Area",
          ""
        );
      } else {
        this.$refs.AssignAreaModal.modalShown = true;
      }
    },
    unmarkAll($event, index, obj, objcompleto) {
      if (objcompleto.stock_area != null) {
        this.$toast.info(
          "El contenido que acaba de seleccionar ya tiene un Area asignada",
          ""
        );
        this.$refs[obj].checked = false;
      } else {
        if ($event.target.checked == true) {
          this.$refs[obj].checked = true;
          this.markedRows.push(objcompleto.id);
          console.log("%o", this.markedRows);
        } else {
          this.$refs[obj].checked = false;
          let deleteIndex = this.markedRows.findIndex(
            item => item.id === objcompleto.id
          );
          this.markedRows.splice(deleteIndex, 1);
          console.log("%o", this.markedRows);
        }
      }
    },
    async getAreas() {
      const thisV = this;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: "bagno/area-stock-all/"
        });

        for (let index in response.data) {
          if (response.data[index].process_type == undefined) {
          } else {
            thisV.Areas.push(response.data[index]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }
      var a = encodeURIComponent(JSON.stringify(result));
      return "/api/v1/stock/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },

    async fetchData() {
      const response = await this.$axios.get(
        this.jsonToQueryString(this.$refs.table.query)
      );
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
